export default __webpack_public_path__ + "static/media/oplocenka_barva-min.374df376.png";